




export default {
  name: 'IconSearch',
};
